<template>
<div class="control-ro">
    <div class="label-ro">
        {{label}}
    </div>
    <div class="value-ro">
        {{value}}
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        label: String,
        value: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
.control-ro {
    display:flex;
    font-size:15px;
}
.label-ro {
    padding: 0px 10px;
    flex-basis: 130px;
    color: #aaa;
    font-weight: 600;
    text-align:right;
    background-color:#eee;
    border-radius:3px;
}
.value-ro {
    padding: 0 10px;
    flex-basis: 200px;
    flex-grow:1;
    font-weight: 400;
    color:#555;
}
</style>




// WEBPACK FOOTER //
// LayoutReadOnly.vue?1ea3b104